import { render, staticRenderFns } from "./reseller.vue?vue&type=template&id=6ffd0ad6&scoped=true"
import script from "./reseller.vue?vue&type=script&lang=js"
export * from "./reseller.vue?vue&type=script&lang=js"
import style0 from "./reseller.vue?vue&type=style&index=0&id=6ffd0ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffd0ad6",
  null
  
)

export default component.exports